import { useMemo } from "react";

import {
  entityPathMappingsAdmin,
  INavigatePossibleActions,
  RydeAdminUnit,
  usePrefixedRouting,
} from "@ryde/shared";

/* this hook is not intended for direct use, use useCrudNavigateAdmin instead */

export const useNavigatePathsAdmin = () => {
  const { navigatePrefixed } = usePrefixedRouting();
  const { addPrefix } = usePrefixedRouting();
  const crudRoutes = useMemo(() => {
    const routes = {} as Record<RydeAdminUnit, INavigatePossibleActions>;

    Object.entries(entityPathMappingsAdmin).forEach(([key, path]) => {
      if (!key) {
        return;
      }

      routes[key as RydeAdminUnit] = {
        list: () => {
          navigatePrefixed(`/${path}`);
        },
        listUrl: addPrefix(`/${path}`),
        new: () => {
          navigatePrefixed(`/${path}/new`);
        },
        edit: (id: number): void => {
          navigatePrefixed(`/${path}/edit/${id}`);
        },
        add: (duplicateFromId?: number) => {
          if (duplicateFromId) {
            navigatePrefixed(`/${path}/add/${duplicateFromId}`);
          } else {
            navigatePrefixed(`/${path}/add`);
          }
        },
      };
    });
    return routes;
  }, [addPrefix, navigatePrefixed]);
  return crudRoutes;
};
